import { render } from "./App.vue?vue&type=template&id=142befb6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=142befb6&lang=css"
script.render = render

export default script